import React from 'react';
import { Icon } from '@app/src/common/Icon';
import {
  Wrapper,
  ButtonAction,
  Content,
  Category,
  HighLights,
  PublicationDate,
  Description,
  Subtitle,
  CheckboxWrapper,
  LoaderWrapper,
  IconWrapper
} from './styled';
import { COLORS } from '@app/src/ui';

interface Props {
  colorCategory?: string;
  handleClickAction?: Function;
  categoryName: string;
  highText: string;
  publicationDate: string;
  operationType: string;
  description: string;
  className?: string;
  isChecked?: boolean;
  inputName?: string;
  inputValue?: string;
  handleChangeCheckbox?: Function;
  isLoadingRepublish?: boolean;
  type?: string;
  state?: number;
}

const AD_ACTIVE = 1;

export const AnnouncementCard: React.FC<Props> = ({
  colorCategory,
  categoryName,
  highText,
  publicationDate,
  operationType,
  description,
  className,
  handleClickAction,
  isChecked,
  inputName,
  inputValue,
  handleChangeCheckbox,
  isLoadingRepublish,
  type,
  state
}) => {
  return (
    <Wrapper className={className}>
      <ButtonAction onClick={handleClickAction}>
        {
          state === AD_ACTIVE ?
            type === 'print' && <IconWrapper
              data-action={'detail'}
              title={'ver detalle'}
            >
              <Icon data-name="icon-detail" fill='#000' width="20" height="20" />
            </IconWrapper>
            :
            type === 'print' &&
            <IconWrapper
              data-action={'republish-print'}
              title='Republicar'
            >
              {
                isLoadingRepublish ?
                  <LoaderWrapper>
                    <Icon data-name='icon-circle' fill='#ccc' width={'16'} height={'16'} />
                  </LoaderWrapper>
                  :
                  <Icon data-name="icon-republish" fill="#000" width="20" height="20" />
              }
            </IconWrapper>
        }
        <IconWrapper
          isDisabled={isChecked}
          data-action='delete'
          title={'Dar de baja'}
        >
          <Icon data-name="icon-trash" fill="#000" width="20" height="20" />
        </IconWrapper>
      </ButtonAction>
      <CheckboxWrapper
        colorActive={COLORS.BLUE_LINK}
        checked={isChecked}
        name={inputName}
        value={inputValue}
        handleChange={handleChangeCheckbox} />
      <Content>
        <Category color={colorCategory}>{categoryName}</Category>
        <HighLights>{highText}</HighLights>
        <PublicationDate>{'Registro'}: {publicationDate}</PublicationDate>
        <Description title={`${operationType} | ${description}`}>
          <Subtitle>{operationType}</Subtitle>: {description}
        </Description>
      </Content>
    </Wrapper>
  )
}